import React, { Component } from 'react';
import isElectron from '../utils/is-electron.js';

import localforage from 'localforage';

class LogoutPage extends Component {
  componentDidMount() {
    // Delete the local session.
    localforage.removeItem('session')
      .then(() => {
        // If we're in Electron, let the Node process know we're logging out.
        if (isElectron()) {
          const { ipcRenderer } = window.require('electron');
          ipcRenderer.send('auth', null);
        }

        // Hard reboot the app into the login page.
        window.location = '/login';
      });
  }

  render() {
    return (
      <div className="LogoutPage"></div>
    );
  }
}

export default LogoutPage;



// WEBPACK FOOTER //
// ./src/containers/LogoutPage.js